export const EMPTY_DOSING_SCHEDULE_DATA = { entries: [] };
//# sourceMappingURL=schedule-types.js.map